import React from 'react';
import "./Teams.css";

const Teams = () => {
  return (
    <section data-bs-version="5.1" className="team1 cid-tROlJnUMRp reveal" id="quienes-somos">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 pb-5">
            <h3 className="mbr-section-title   align-center mb-3 display-2">
              <strong>El equipo de asistai</strong>
            </h3>
            <p className="mbr-section-subtitle   align-center mb-3 display-7">
              <strong>Directivos Visionarios</strong>: Con un ojo en el futuro, nuestros líderes están transformando la atención al cliente mediante la inteligencia artificial.<br />
              <strong>Técnicos de Élite:</strong> Expertos en IA, comprometidos con la calidad y la innovación en cada proyecto que emprendemos.<br />
              <strong>Tu Éxito es Nuestro Objetivo:</strong> Nos adaptamos a tus necesidades para ofrecerte soluciones a medida que impulsan tu negocio.
            </p>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card-wrap">
              <div className="image-wrap">
                <img src="assets/images/presentador-592x592.png" alt="" />
              </div>
              <div className="content-wrap">
                <h5 className="mbr-section-title card-title   align-center m-0 display-5">
                  <strong>Clift Radler</strong>
                </h5>
                <h6 className="mbr-role   align-center mb-3 display-4">
                  <strong>CEO</strong>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card-wrap">
              <div className="image-wrap">
                <img src="assets/images/marketing1-592x592.png" alt="" />
              </div>
              <div className="content-wrap">
                <h5 className="mbr-section-title card-title   align-center m-0 display-5">
                  <strong>Sarah Bozano</strong>
                </h5>
                <h6 className="mbr-role   align-center mb-3 display-4">
                  <strong>Director of Marketing</strong>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card-wrap">
              <div className="image-wrap">
                <img src="assets/images/aistente6-592x592.png" alt="" />
              </div>
              <div className="content-wrap">
                <h5 className="mbr-section-title card-title   align-center m-0 display-5">
                  <strong>Helen Swift</strong>
                </h5>
                <h6 className="mbr-role   align-center mb-3 display-4">
                  <strong>TRADER</strong>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card-wrap">
              <div className="image-wrap">
                <img src="assets/images/desarrollador-592x592.png" alt="" />
              </div>
              <div className="content-wrap">
                <h5 className="mbr-section-title card-title   align-center m-0 display-5">
                  <strong>Adam Perk</strong>
                </h5>
                <h6 className="mbr-role   align-center mb-3 display-4">
                  <strong>IA Developer</strong>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teams;
